export default __webpack_public_path__ + "static/media/header.0d8a0d57.png";